module.exports = __webpack_public_path__ + "static/media/auto5.5acc98f2.webp";